var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var listeners = {};
var windowEventListeners = {};
export function clearGlobalState() {
    listeners = {};
    Object.entries(windowEventListeners).forEach(function (_a) {
        var _b = __read(_a, 2), eventName = _b[0], listener = _b[1];
        return window.removeEventListener(eventName, listener);
    });
    windowEventListeners = {};
}
export var addWindowEventListener = function (eventName, eventListener) {
    if (!eventListener) {
        return false;
    }
    if (!listeners[eventName]) {
        listeners[eventName] = [];
    }
    if (listeners[eventName].length === 0) {
        windowEventListeners[eventName] = function (event) {
            listeners[eventName].forEach(function (listener) { return listener(event); });
        };
        window.addEventListener(eventName, windowEventListeners[eventName]);
    }
    listeners[eventName].push(eventListener);
    return true;
};
export var removeWindowEventListener = function (eventName, eventListener) {
    if (!eventListener || !listeners[eventName]) {
        return false;
    }
    var index = listeners[eventName].indexOf(eventListener);
    if (index === -1) {
        return false;
    }
    listeners[eventName].splice(index, 1);
    if (listeners[eventName].length === 0) {
        window.removeEventListener(eventName, windowEventListeners[eventName]);
    }
    return true;
};
